/**
 * DE-1545 F-041 — per-step claim-next routing.
 *
 * `handleStartFeed` historically always navigated to `/verify/:id`, but a
 * classify lane must open the Classification Station, not the Verification
 * Station. This pure helper maps the lane's step type to the right work-surface
 * route for a freshly-claimed document.
 *
 * The Classification Station is the `/ops/classify` queue page; we pass the
 * claimed `documentId` so it preselects that doc.
 */
export function resolveFeedRoute(stepType: string, documentId: string): string {
  if (stepType === "classify") {
    return `/ops/classify?documentId=${encodeURIComponent(documentId)}`;
  }
  // key / verify / qc / supervisor — and any unknown step — open the VS.
  return `/verify/${documentId}`;
}

/**
 * SP3 §3 — remittance work is claimed as a BATCH, not a document, so it can't
 * use resolveFeedRoute (which is document-id keyed). The claim response
 * carries a `batch.id`; both claim entry points navigate here.
 */
export function remittanceStationRoute(batchId: string): string {
  return `/ops/remittance/${batchId}`;
}
